import React from "react";
import { useParams } from "react-router";
import { useTranslation } from "react-i18next";
import { Box } from "@mui/material";
import { useListAndSearchAllAccounts } from "@rentablo/api/apiv1";
import { Banner, LoadingProgressBar } from "@rentablo/components";
import { PageLayout } from "@components";
import { AccountEditHeader } from "@features/accounts/edit/components/AccountEditHeader";
import { ReferenceAccountsCard } from "./components/ReferenceAccountsCard";

export const ReferenceAccountEditPage = () => {
  const { depotId } = useParams<"depotId">();
  const { t } = useTranslation();

  const parsedDepotId = Number.parseInt(depotId!, 10);

  const {
    data: accountList,
    isLoading,
    isError,
  } = useListAndSearchAllAccounts();
  const accounts = accountList?.accounts ?? [];
  const depot = accounts.find((a) => a.id === parsedDepotId);

  if (isLoading) return <LoadingProgressBar />;
  if (isError)
    return (
      <Banner
        type="error"
        title={t("form.errors.somethingWentWrong")}
        displayDefaultIcon
      />
    );
  if (!depot) throw new Response("Not Found", { status: 404 });

  return (
    <PageLayout
      breadcrumbs={[
        { to: "/", text: t("breadcrumbs.home") },
        { to: "/depots-accounts", text: t("breadcrumbs.depotsAccounts") },
        { to: `/depots/${depotId}`, text: depot.name ?? "" },
        { text: t("referenceAccountPage.breadcrumb") },
      ]}
    >
      <Box maxWidth={760}>
        <AccountEditHeader account={depot} />
        <ReferenceAccountsCard depotId={parsedDepotId} />
      </Box>
    </PageLayout>
  );
};
